import clsx from 'clsx';
import React from 'react';

export * from './tools';

interface EmojiProps {
  type: string;
  [key: string]: string;
}

export const Emoji: React.FC<EmojiProps> = ({ type, ...props }) => {
  return <i className={clsx('emoji-icon', type)} {...props}></i>;
};

export default Emoji;
